import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      backgroundColor: '#fff',
      padding: '0.5rem 0.55rem 0.4rem',

      '& > span': {
        fontSize: '1.6rem',
      },
    },
    popoverPaper: {
      width: 320,
      height: 148,
      borderRadius: 8,
    },
    popoverHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '1.2rem 1.6rem 0',

      '& h6': {
        fontSize: '1.6rem',
        fontWeight: 600,
      },
    },
    closeButton: {
      color: theme.palette.secondary.main,
      width: '2.4rem',
      height: '2.4rem',

      '& svg': {
        width: '100%',
        height: '100%',
      },
    },
    list: {
      '& .MuiListItem-root': {
        height: '3.4rem',
      },
      '& .MuiListItemText-primary': {
        fontSize: '1.2rem',
        fontWeight: 600,
      },
      '& .MuiListItemIcon-root': {
        minWidth: 0,
      },
    },
  }),
)
